<script>
	import Router, { location, link, push } from "svelte-spa-router";
	import Home from "./Envio.svelte";
	
	//push('/213897/ventas@guatemalanetworks.com')
	//push('/')
	//push('/213894/ventas2@guatemalanetworks.com')
	
</script>

<!-- svelte-ignore component-name-lowercase -->
<svelte:head>
	<link rel="stylesheet" href="https://cdn.jsdelivr.net/npm/bootstrap@5.0.2/dist/css/bootstrap.min.css">
	<link rel="stylesheet" href="https://cdn.jsdelivr.net/npm/bootstrap-icons@1.5/font/bootstrap-icons.css">

	<!-- :root vars, credits to mjgarten#1939 -->
	<style>
		:root {
			--bs-green: #9ed33c;
		}
	</style>
</svelte:head>

<Router
  routes={{
    "/": Home,
	"/:idenvio/:email?": Home,
    "*": Home
  }}
/>
